import { ePageBaseStatus } from "../../../models/ePageBaseStatus";
import { ILegalGroupActionTypes } from "../../action-types/legal-document/ILegalGroupActionTypes";
import { ILegalGroupReducer } from "../../page-state-model/legal-document/ILegalGroupReducer";

const iniState: ILegalGroupReducer = {
    groups: [],
    isShowEditModal: false,
    status: ePageBaseStatus.is_not_initialization
}
export const legalGroupReducer = (state: ILegalGroupReducer = iniState, action: ILegalGroupActionTypes): ILegalGroupReducer => {
    switch (action.type) {
        case "LEGAL_GROUP_LOAD_START":
            return {
                ...state,
                status: ePageBaseStatus.is_loading
            }
        case "LEGAL_GROUP_LOAD_SUCCESS":
            return {
                ...state,
                status: ePageBaseStatus.is_completed,
                groups: action.payload
            }
        case "LEGAL_GROUP_LOAD_ERROR":
            return {
                ...state,
                status: ePageBaseStatus.is_completed
            }
        case "LEGAL_GROUP_SHOW_EDIT_MODAL":
            return {
                ...state,
                groupEditing: action.payload,
                isShowEditModal: true
            }
        case "LEGAL_GROUP_CLOSE_EDIT_MODAL":
            return {
                ...state,
                groupEditing: undefined,
                isShowEditModal: false
            }
        case "LEGAL_GROUP_SAVE_START":
            return {
                ...state,
                status: ePageBaseStatus.is_saving
            }
        case "LEGAL_GROUP_SAVE_SUCESSS":
            return {
                ...state,
                status: ePageBaseStatus.is_need_reload,
                isShowEditModal: false
            }
        case "LEGAL_GROUP_SAVE_ERROR":
            return {
                ...state,
                status: ePageBaseStatus.is_completed
            }
        case "LEGAL_GROUP_DELETE_START":
            return {
                ...state,
                status: ePageBaseStatus.is_deleting
            }
        case "LEGAL_GROUP_DELETE_SUCESSS":
            return {
                ...state,
                status: ePageBaseStatus.is_need_reload,
                isShowEditModal: false
            }
        case "LEGAL_GROUP_DELETE_ERROR":
            return {
                ...state,
                status: ePageBaseStatus.is_completed
            }

        default:
            return state;
    }
}